import mutations, {defaultState} from "./mutations";
import getters from "./getters";
import actions from "./actions";

export const namespace = "fnApp";

export const appStore = (action) => {
    return namespace + "/" + action;
};

/**
 * App store object for managing the app
 *
 * @constructor
 */
export const app = {
    namespaced: true,
    state: defaultState,
    getters,
    mutations,
    actions
};

export default {
    /**
     * Install the auth store into the app store
     *
     * @param store {{registerModule: function(string,Object)}}
     */
    install: function(store){
        store.registerModule(namespace, app);
    }
};
